"use strict";

var _excluded = ["trackView"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback, useEffect, useMemo } from 'react';
import { useFlixApiContext } from '../FlixApiContext';
import { useFilmDetailsFetch, useFilmDetailsQuery } from '../content/FilmDetails/useFilmDetailsQuery';
import { TRAILER_VIEWED } from '../eventsNames';

var filmDetailsToPlaylist = function filmDetailsToPlaylist(result) {
  var _result$data;

  var seekTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var film = (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.film;
  return !film ? result : _objectSpread(_objectSpread({}, result), {}, {
    data: {
      film: film,
      playlist: [_objectSpread(_objectSpread({}, film.trailer), {}, {
        title: film.title,
        seekTimeType: 'trailer',
        seekTime: seekTime
      })]
    }
  });
};

export var useFilmTrailerPlaylistFetch = function useFilmTrailerPlaylistFetch() {
  var _useFlixApiContext = useFlixApiContext(),
      events = _useFlixApiContext.events;

  var fetchFilmDetails = useFilmDetailsFetch();
  return useCallback(function (_ref) {
    var slug = _ref.slug;
    return fetchFilmDetails(slug).then(filmDetailsToPlaylist).then(function (result) {
      result.data && events.emit(TRAILER_VIEWED, result.data.film.slug);
      return result;
    });
  }, [fetchFilmDetails, events]);
};
export var useFilmTrailerPlaylistQuery = function useFilmTrailerPlaylistQuery(slug, initialSeekTime) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref2$trackView = _ref2.trackView,
      trackView = _ref2$trackView === void 0 ? true : _ref2$trackView,
      options = _objectWithoutProperties(_ref2, _excluded);

  var _useFlixApiContext2 = useFlixApiContext(),
      events = _useFlixApiContext2.events;

  useEffect(function () {
    if (trackView) {
      events.emit(TRAILER_VIEWED, slug);
    }
  }, [events, slug, trackView]);
  var result = useFilmDetailsQuery({
    slug: slug
  }, options);
  return useMemo(function () {
    return filmDetailsToPlaylist(result, initialSeekTime);
  }, [result.data] // eslint-disable-line react-hooks/exhaustive-deps
  );
};